import { SFHotelDomesticContentViewModel } from '@api/index';
import Markdown from '@components/utils/Markdown';

import {
  TagLinkItem,
  TagLinksContainer,
  TagLinksContent,
  TagLinksItem,
  TagLinksList,
  TagLinksTitle,
} from './styled';

const TagLinks = ({
  title,
  content,
  items,
}: SFHotelDomesticContentViewModel) => {
  return (
    <TagLinksContainer>
      <TagLinksTitle>
        <h2>{title}</h2>
      </TagLinksTitle>
      <TagLinksContent>
        <Markdown text={content} />
      </TagLinksContent>
      <TagLinksList>
        {items?.map(({ name, href }) => (
          <TagLinkItem key={name}>
            <TagLinksItem href={href} prefetch={false}>
              {name}
            </TagLinksItem>
          </TagLinkItem>
        ))}
      </TagLinksList>
    </TagLinksContainer>
  );
};

export default TagLinks;
